import { swalMessages } from '@auteco/constants'
import React, { useEffect, useState } from 'react'
import ActionsPage from '@auteco/pages/GvcPage/ActionsPage/ActionsPage'
import { getPartnersActions } from '@auteco/services/GvcServices'
import swal from 'sweetalert'

const ActionsContainer = () => {
  const [partnersActions, setPartnersActions] = useState([])
  const fetchPartnersActions = async () => {
    const { success, data } = await getPartnersActions()
    if (success) {
      setPartnersActions(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  useEffect(() => {
    fetchPartnersActions()
  }, [])
  return (
    <ActionsPage
      partners={partnersActions}
    />
    )
}

export default ActionsContainer